var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.407 7h-8.814c-.873 0-1.582.71-1.582 1.582v14.836c0 .872.71 1.582 1.582 1.582h8.814c.872 0 1.582-.71 1.582-1.582V8.582c0-.872-.71-1.582-1.582-1.582ZM16 9.55a1.741 1.741 0 1 1 0 3.483 1.741 1.741 0 0 1 0-3.483Zm0 13.112a4.162 4.162 0 0 1-4.158-4.158A4.162 4.162 0 0 1 16 14.347a4.162 4.162 0 0 1 4.157 4.157A4.162 4.162 0 0 1 16 22.662Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75c-.967 0-1.754.787-1.754 1.754s.787 1.754 1.754 1.754 1.754-.787 1.754-1.754S16.967 16.75 16 16.75Z",
    fill: "#fff"
  })));
};
export default SvgHouse;